import JSEncrypt from 'jsencrypt/bin/jsencrypt'

const publicKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAopj/xq0Acayxsix+b3EwikuciOYuH+K/3tmFhAoyEaMvAsmo1jFXJd4xC/
au3gIvaWtyP5klBUM4jQVDvtHdfVBKsHNp7C7TOFeUPU01UFqgtLAxLa5o/xAqF6AUViNoYSz2qtm7+Odl5BJmwmAmIN+Af68AbX8+SLI2CRpWa+tmmAmoTe/
CEst2LRoL0VQ6LeUurwVLSzeUKeVupq/Y7s4R3/ZJVwsbhUFVkiQT5szGM9fglOVlFydkubRl90IJPW7V0MsOZJkzXdL61tLHwM/G9aYCZIqVrwiz8ZXW/yG4ZAB+wWskLuo+N+wmblhhnq8RaFmiznurVziEXmCAfwIDAQAB`
const encryptor = new JSEncrypt()
encryptor.setPublicKey(publicKey)
/**
 * rsa加密
 * @param {Object} content
 * @returns {Object}
 */
export function encrypt(content) {
  // 对需要加密的数据进行加密
  return encryptor.encrypt(content)
}
